import { ComposerEditableEntityAnalyticsData } from 'cio/utils/composer/composer-editable-entity';
import { Editor } from 'cio/services/editor';

// Ported from https://github.com/customerio/services/blob/main/helpers/builder_type.go
export default function getBuilderType(data: ComposerEditableEntityAnalyticsData | null | undefined) {
  let template = data?.template;
  let editor = data?.editor ?? '';
  if (!template) {
    return 'Unknown';
  }

  if (template.templateType === 'push') {
    return editor === Editor.JSON ? 'Custom Payload' : 'Rich Push';
  }
  if (template.templateType === 'twilio') {
    return template.whatsapp ? 'Whatsapp' : 'SMS';
  }

  switch (editor) {
    case Editor.RICH_TEXT:
      return 'Rich Text';
    case Editor.CODE:
      return 'Code';
    case Editor.DRAG_AND_DROP:
      return 'Drag n Drop';
    case Editor.VISUAL:
      return 'Visual';
  }

  return 'Unknown';
}
